import React from "react";

import { Column, ColumnId } from ".";
import base from "./base";

import SMSStatusCellContent from "../components/SMSStatusCellContent";
import { MessageTemplateActions } from "../../../../../../types/MessageTemplateEnums";

function smsExecutorSwitchedStatus({
	width,
	onResize,
	language,
}: Column.Options) {
	return base(
		ColumnId.SMSExecutorSwitchedStatus,
		(item) => (
			<SMSStatusCellContent
				item={item}
				type={MessageTemplateActions.DRIVER_SWITCHED}
				language={language}
			/>
		),
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default smsExecutorSwitchedStatus;
